import React from 'react';
import { motion } from 'framer-motion';
export const IntroAnimation = () => {
  return <motion.div initial={{
    opacity: 1
  }} animate={{
    opacity: 0,
    pointerEvents: 'none'
  }} transition={{
    duration: 1.2,
    delay: 2.5,
    ease: 'easeInOut'
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-black" data-id="element-61">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1,
      ease: 'easeOut'
    }} className="relative flex items-center justify-center w-48 h-48 rounded-full border border-gold shadow-gold-glow-strong" data-id="element-62">
        {/* Inner glowing ring */}
        <div className="absolute inset-0 rounded-full border-2 border-gold opacity-50 blur-sm" data-id="element-63"></div>

        {/* Sparkles (static representation) */}
        <div className="absolute -top-2 -right-2 text-gold text-xl" data-id="element-64">✨</div>
        <div className="absolute -bottom-4 -left-2 text-gold text-lg" data-id="element-65">✨</div>

        <span className="font-serif text-6xl text-gold text-glow tracking-widest ml-2" data-id="element-66">
          FLA
        </span>
      </motion.div>
    </motion.div>;
};